import React from 'react';
import { NODE_DEFS, PALETTE_GROUPS } from '../../data/nodeDefinitions';
import Icon from '../ui/Icon';
import styles from './NodePalette.module.css';

class NodePalette extends React.Component {
  render() {
    const { onAdd } = this.props;

    return (
      <div className={styles.palette}>
        {PALETTE_GROUPS.map(group => (
          <div key={group.label} className={styles.section}>
            <div className={styles.sectionLabel}>{group.label}</div>
            {group.nodes.map(type => {
              const def = NODE_DEFS[type];
              return (
                <div
                  key={type}
                  className={styles.node}
                  draggable
                  onDragStart={(e) => {
                    e.dataTransfer.setData('application/journey-node-type', type);
                    e.dataTransfer.effectAllowed = 'move';
                  }}
                  onClick={() => onAdd(type)}
                  title={def.comingSoon ? `${def.label} — the journey engine doesn't run this step type yet, but you can still plan with it.` : def.label}
                >
                  <div className={styles.nodeIco} style={{ background: def.icoC, color: def.icoT }}>
                    <Icon name={def.ico} size={16} />
                  </div>
                  <div className={styles.nodeInfo}>
                    <div className={styles.nodeNameRow}>
                      <div className={styles.nodeName}>{def.label}</div>
                      {def.comingSoon && <span className={styles.soonBadge}>Soon</span>}
                    </div>
                    <div className={styles.nodeDesc}>{_desc(type)}</div>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  }
}

function _desc(type) {
  const DESCS = {
    'entry':           'Audience · timing · re-entry',
    'entry-event':     'On user action',
    'entry-schedule':  'Daily, weekly, cron',
    'entry-segment':   'On segment membership',
    'entry-api':       'External trigger',
    'action-push':     'FCM · APNs · in-app inbox',
    'action-whatsapp': 'Template message',
    'action-email':    'HTML email',
    'action-sms':      'Text message',
    'action-rcs':      'Rich messaging',
    'action-webhook':  'HTTP callback',
    'wait-relative':   'Wait 1h · 6h · 3d',
    'wait-absolute':   'Next day 12 PM',
    'logic-condition': 'Yes / No branch',
    'logic-ab':        '% random split',
    'logic-goal':      'Exit if achieved',
    'logic-exit':      'End journey',
  };
  return DESCS[type] || '';
}

export default NodePalette;
